import { render } from "./HeroiconsSolidHand.vue?vue&type=template&id=63522f70"
const script = {}

import exportComponent from "/var/www/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidHand.vue"]])

export default __exports__